import React from 'react';
import UserItem from './SuperhostItem'
import TablePagination from 'components/Pagination/TablePagination';
import Headers from './Headers';

export const SuperhostList = ({
  superhosts,
  checkedUserIds,
  user_ids,
  paginationProps,
  onOrderChange,
  query
})  => <table>
        <Headers
          // onChange={onOrderChange}
          //   value={query.order}
          />
          { superhosts.map(user => (
            <UserItem
              user={user}
              checkedUserIds={checkedUserIds}
              key={user.id}
              user_ids={user_ids}
            />
          ))}
          <tr>
            <td colSpan="9">
              <TablePagination
                {...paginationProps}
              />
            </td>
          </tr>
    </table>



// WEBPACK FOOTER //
// ./src/components/Admin/Superhosts/List/SuperhostList.jsx